import { restClient } from '../config/restClient'

const endpoint = companyId => `/api/company/v2/company_profiles/${companyId}/account_manager`

export const getAccountManager = async companyId => {
  const response = await restClient(endpoint(companyId), {
    method: 'GET',
  })
  return response.data
}
